// Shared site data, used across pages
import {
  ShieldCheck, Bell, FileSignature, Calendar, Users, FileLock, BarChart3, Workflow,
  PenLine, Building2, GitBranch, MonitorSmartphone, Network, Briefcase, KeyRound,
  ScrollText, ArrowUpRightSquare, FileText, Lock,
} from "lucide-react";

// 14 feature modules, used on Features page + solution pages
export const FEATURE_MODULES = [
  { key: "statutory-registers", Icon: FileText, title: "Statutory Registers",
    desc: "Maintain register of members, directors, PSCs, charges and more, kept in real time with full audit trail.",
    category: "records" },
  { key: "e-fillings", Icon: ArrowUpRightSquare, title: "E-Fillings",
    desc: "Generate, validate and submit Companies House forms (CS01, AP01, TM01, PSC, SH01) without leaving the app.",
    category: "records" },
  { key: "people-management", Icon: Users, title: "People Management",
    desc: "Manage directors, secretaries and officers, with appointments, resignations and ECCTA identity verification.",
    category: "records" },
  { key: "share-capital", Icon: BarChart3, title: "Share Capital & Shareholders",
    desc: "Allotments, transfers, consolidations and shareholder registers, accurate, auditable, and Companies-House-ready.",
    category: "records" },
  { key: "board-meetings", Icon: Briefcase, title: "Board & Committee Meetings",
    desc: "Schedule meetings, build agendas, distribute board packs and capture minutes with AI-assisted drafts.",
    category: "governance" },
  { key: "automated-documents", Icon: FileSignature, title: "Automated Documents",
    desc: "Generate workflow documents from dynamic templates, resolutions, minutes, share certificates and more.",
    category: "governance" },
  { key: "e-signatures", Icon: PenLine, title: "e-Signatures",
    desc: "Secure, user-friendly electronic signatures so resolutions and statutory documents are signed in minutes, not weeks.",
    category: "governance" },
  { key: "workflow-automation", Icon: Workflow, title: "Workflow Automation",
    desc: "Repeatable workflows for incorporations, board cycles, PSC reviews, fewer steps, fewer mistakes.",
    category: "automation" },
  { key: "alerts-reminders", Icon: Bell, title: "Alerts & Reminders",
    desc: "Configurable email, in-app and dashboard alerts so statutory deadlines never sneak up on you again.",
    category: "automation" },
  { key: "task-tracking", Icon: Calendar, title: "Task Tracking",
    desc: "Plan compliance actions, assign owners and follow-up cadences, and track every responsibility to completion.",
    category: "automation" },
  { key: "organisation-structure", Icon: GitBranch, title: "Organisation Structure",
    desc: "Visualise parent–subsidiary structures, cross-holdings and inter-company relationships across groups.",
    category: "intelligence" },
  { key: "personal-dashboard", Icon: MonitorSmartphone, title: "Personal Dashboard",
    desc: "Build interactive dashboards and reports per role, the right insights surfaced to the right person.",
    category: "intelligence" },
  { key: "multi-device", Icon: Network, title: "Multi-Device Support",
    desc: "Access company secretarial data securely from any device, anytime, desktop, tablet, mobile.",
    category: "intelligence" },
  { key: "role-based-auth", Icon: KeyRound, title: "Role-Based Authentication",
    desc: "Granular access controls so the right team members see the right entities and matters.",
    category: "intelligence" },
];

export const FEATURE_CATEGORIES = [
  { key: "records", label: "Records & Filings", desc: "Statutory data and Companies House submissions, fully managed." },
  { key: "governance", label: "Governance", desc: "Boardrooms, minutes, resolutions and signatures." },
  { key: "automation", label: "Automation", desc: "Workflows and reminders that replace manual admin." },
  { key: "intelligence", label: "Intelligence & Access", desc: "Dashboards, structures and secure access." },
];

export const OFFICES = [
  { city: "London", address: "20-22 Wenlock Road, London, England, N1 7GU, United Kingdom" },
  { city: "Hyderabad", address: "Rhodium House, Plot No. 52, 2nd Floor, Guttala Begumpet, Kavuri Hills, Madhapur, Hyderabad, Telangana 500033, India" },
];

export const CONTACT = {
  phone: "+44 330 133 2696",
  phoneHref: "tel:+443301332696",
  email: "contact@cosecglobal.com",
  emailHref: "mailto:contact@cosecglobal.com",
  social: {
    linkedin: "https://www.linkedin.com/company/cosecglobal",
    x: "https://x.com/cosecglobal",
    facebook: "https://www.facebook.com/cosecglobal",
    youtube: "https://www.youtube.com/@cosecglobal",
    instagram: "https://www.instagram.com/cosecglobal",
  },
};

export const COMPARE_ROWS = [
  { label: "UK-native (Companies Act 2006, ECCT Act 2023, Companies House gateway)", cs: true, other: "limited" },
  { label: "AI-assisted minute-taking and document drafting", cs: true, other: "limited" },
  { label: "Built for company secretaries (primary persona)", cs: true, other: "limited" },
  { label: "Statutory registers + Companies House filing in one app", cs: true, other: "limited" },
  { label: "Free trial", cs: true, other: "limited" },
  { label: "Transparent pricing on website", cs: true, other: "limited" },
  { label: "Built for groups of 50+ entities", cs: true, other: "limited" },
  { label: "Public APIs", cs: true, other: "limited" },
];

export const STATS = [
  { k: "247", l: "UK entities managed on CoSec App" },
  { k: "312", l: "Confirmation statements filed in last 12 months" },
  { k: "18 hrs", l: "Cosec admin automated per team per month" },
  { k: "200+", l: "Integrations available" },
];

export const ICON_LOOKUP = { ShieldCheck, Bell, FileSignature, Calendar, Users, FileLock, BarChart3, Workflow, PenLine, Building2, GitBranch, MonitorSmartphone, Network, Briefcase, KeyRound, ScrollText, ArrowUpRightSquare, FileText, Lock };
